module.exports = __webpack_public_path__ + "static/media/printer.2663270c.png";